import React from 'react';
import { func } from 'prop-types';
import styles from './styles/styles.module.scss';
import BottomTray from '../../shared/BottomTray';
import Button from '../../shared/Button';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    GIFT_FLOW: { CHOOSE_A_CHECKOUT_METHOD, CHECKOUT_AS_GUEST },
    SIGNUP: { LOGIN }
  }
} = StringConstantsMixin;

const GiftTray = ({ closeTray, navigateTo }) => {
  return (
    <BottomTray closeTray={closeTray}>
      <div className={styles.container}>
        <div className={styles.trayContent}>
          <div className={styles.spacer} />
          <div className={styles.buttonContainer}>
            <div className={styles.headline}>{CHOOSE_A_CHECKOUT_METHOD}</div>
            <Button variant="primary" classes={styles.button} onClick={() => navigateTo('/gift/login')}>
              {LOGIN}
            </Button>
            <Button variant="secondary" classes={styles.button} onClick={() => navigateTo('/gift/payment')}>
              {CHECKOUT_AS_GUEST}
            </Button>
          </div>
        </div>
      </div>
    </BottomTray>
  );
};

GiftTray.propTypes = {
  closeTray: func.isRequired,
  navigateTo: func.isRequired
};

export default GiftTray;
